import Model, { attr, belongsTo } from '@ember-data/model';
import { validator, buildValidations } from 'ember-cp-validations';

import { MAX_LISTENER_TITLE_CHARACTER_LENGTH } from 'social-listening/types/validations';

import type GroupModel from 'later/models/group';
import type SocialProfileModel from 'later/models/social-profile';

export const ListenerType = {
  Hashtag: 'InstagramHashtagListener',
  Mention: 'InstagramMentionListener',
  User: 'InstagramUserListener'
} as const;

export type ListenerTypeKeys = keyof typeof ListenerType;
export type ListenerTypes = (typeof ListenerType)[ListenerTypeKeys];

const Validations = buildValidations({
  name: [
    validator('presence', {
      presence: true,
      messageKey: 'social-listening.create.form.errors.title.empty'
    }),
    validator('length', {
      max: MAX_LISTENER_TITLE_CHARACTER_LENGTH,
      message: 'social-listening.create.form.errors.title.length'
    })
  ],
  includedHashtags: validator('inline', {
    validate(_value: unknown, _options: unknown, model: ListenerModel) {
      return model.hasTopicOrProfile || 'social-listening.create.form.errors.hashtag.empty';
    }
  }),
  includedProfiles: validator('inline', {
    validate(_value: unknown, _options: unknown, model: ListenerModel) {
      return model.hasTopicOrProfile || 'social-listening.create.form.errors.profile.empty';
    }
  })
});

export default class ListenerModel extends Model.extend(Validations) {
  @belongsTo('socialProfile') declare socialProfile: SocialProfileModel;
  @belongsTo('group') declare group: GroupModel;
  @attr('string') declare createdAt: string;
  @attr('string') declare name: string;
  // @ts-expect-error Fixed in @types/ember-data v4
  @attr('array') declare includedHashtags: string[];
  // @ts-expect-error Fixed in @types/ember-data v4
  @attr('array') declare includedProfiles: string[];
  // @ts-expect-error Fixed in @types/ember-data v4
  @attr('array') declare excludedHashtags: string[];
  // @ts-expect-error Fixed in @types/ember-data v4
  @attr('array') declare excludedProfiles: string[];

  get hasIncludedHashtags(): boolean {
    return this.includedHashtags.length > 0;
  }

  get hasIncludedProfiles(): boolean {
    return this.includedProfiles.length > 0;
  }

  get hasTopicOrProfile(): boolean {
    return this.hasIncludedHashtags || this.hasIncludedProfiles;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    listener: ListenerModel;
  }
}
